import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-8c918bc2")
const _hoisted_1 = { class: "top-nav" }
const _hoisted_2 = { class: "fuc" }
const _hoisted_3 = { class: "user-info" }
const _hoisted_4 = ["title"]
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("span", null, _toDisplayString(_ctx.username), 1),
        _createElementVNode("i", {
          onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.logout && _ctx.logout(...args)), ["stop"])),
          title: _ctx.lang('mainAccount.info.logout'),
          class: "el-icon-warning-outline"
        }, null, 8, _hoisted_4)
      ])
    ])
  ]))
}